import {
  Box,
  Button,
  Card,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  makeStyles,
  Menu,
  MenuItem,
  Radio,
  Grid,
} from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import React, { useEffect, useRef, useState } from 'react';
import SearchBar from 'src/components/SearchBar';

const useStyles = makeStyles(theme => ({
  root: {},
  menuItem: {
    padding: 0,
  },
  formControlLabel: {
    padding: theme.spacing(0.5, 2),
    width: '100%',
    margin: 0,
  },
  searchInput: {
    marginLeft: theme.spacing(2),
  },
  chip: {
    margin: theme.spacing(1),
  },
  textDanger: {
    color: '#e14646',
  },
  menu: {
    height: '50vh',
  },
}));

function CustomSearch({
  handleSearch,
  placeholder,
  hidebutton,
  showFilters,
  selectedFilters,
  setSelectedFilters,
  filterOptions,
  dateRangeFilter,
  handleDateRangeFilter,
}) {
  const classes = useStyles();
  // eslint-disable-next-line no-unused-vars
  const [inputValue, setInputValue] = useState('');
  const [chips, setChips] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [dateRange, setDateRange] = useState({
    startDate: new Date(new Date().setDate(new Date().getDate() - 30)), // 30 days prior date
    endDate: new Date(),
  });
  const handleDateSelect = ({ name, value }) => {
    setDateRange(state => ({
      ...state,
      [name]: value,
    }));
  };
  const handleDateRangeSearch = () => {
    setErrorMessage(null);
    if (dateRange.startDate < dateRange.endDate) {
      handleDateRangeFilter(dateRange);
    } else {
      setErrorMessage('Select proper date range!');
    }
  };
  const handleInputChange = event => {
    event.persist();
    setInputValue(event.target.value);
    if (showFilters) {
      setSelectedFilters(prevState => ({
        ...prevState,
        searchTerm: event.target.value,
      }));
    } else {
      handleSearch(event.target.value);
    }
  };

  const handleChipDelete = chip => {
    setChips(prevChips => prevChips.filter(prevChip => chip !== prevChip));
    const data = { ...selectedFilters };
    const filterKeys = Object.keys(data);
    for (let i = 0; i < filterKeys.length; i++) {
      if (data[filterKeys[i]].length > 0 && typeof data[filterKeys[i]] === 'object') {
        for (let j = 0; j < data[filterKeys[i]].length; j++) {
          if (data[filterKeys[i]][j] === chip) {
            const filteredArr = data[filterKeys[i]].filter(item => item !== chip);
            setSelectedFilters(prevState => ({
              ...prevState,
              [filterKeys[i]]: filteredArr,
            }));
          }
        }
      }
    }
  };

  const handleMultiSelectChange = value => {
    setChips(value);
  };

  return (
    <Card>
      <Box display="flex" alignItems="center">
        <SearchBar
          onChange={handleInputChange}
          placeholder={placeholder}
          hidebutton={hidebutton}
          height="76px"
          padding="16px"
        />
      </Box>
      <Divider />
      <Box sx={{ m: 2 }}>
        {dateRangeFilter && (
          <Grid container alignItems="center" justify="start">
            <Grid item md={4} lg={3}>
              <DatePicker
                disableToolbar
                variant="inline"
                required
                label={'Start Date'}
                format="MM/DD/YYYY"
                name={'startDate'}
                value={dateRange?.startDate}
                onChange={date => handleDateSelect({ value: date, name: 'startDate' })}
                animateYearScrolling
                inputVariant="outlined"
              />
            </Grid>
            <Grid item md={3}>
              <DatePicker
                disableToolbar
                variant="inline"
                required
                label={'End Date'}
                format="MM/DD/YYYY"
                name={'endDate'}
                value={dateRange?.endDate}
                onChange={date => handleDateSelect({ value: date, name: 'endDate' })}
                animateYearScrolling
                inputVariant="outlined"
              />
            </Grid>
            <Grid item md={2}>
              <Button
                variant="contained"
                onClick={() => handleDateRangeSearch()}
                className={classes.btnAddUser}
                color="primary"
                data-test="add-coupon-btn"
              >
                <SearchOutlinedIcon />
                Search
              </Button>
              {errorMessage ? <p className={classes.textDanger}>{errorMessage}</p> : null}
            </Grid>
            <Grid item md={2} lg={2}></Grid>
          </Grid>
        )}
      </Box>
      {showFilters && (
        <>
          <Box p={0} display="flex" alignItems="center" flexWrap="wrap">
            {chips.map(chip => (
              <Chip
                className={classes.chip}
                key={chip}
                label={chip}
                onDelete={() => handleChipDelete(chip)}
              />
            ))}
          </Box>
          <Divider />
          <Box display="flex" alignItems="center" flexWrap="wrap" p={1}>
            {filterOptions.map(option => (
              <MultiSelect
                key={option.label}
                label={option.label}
                config={option}
                onChange={e => handleMultiSelectChange(e, option.key)}
                options={option.options}
                value={chips}
                optionKey={option.key}
                setSelectedFilters={setSelectedFilters}
                selectedFilters={selectedFilters}
                labelType={option.labelType}
                multiLevelOptions={option.multiLevelOptions}
                optionType={option.optionType}
              />
            ))}
            <Box flexGrow={1} />
          </Box>
        </>
      )}
    </Card>
  );
}

export function MultiSelect({
  label,
  options,
  value,
  onChange,
  optionKey,
  setSelectedFilters,
  selectedFilters,
  labelType,
  multiLevelOptions,
  optionType,
}) {
  const classes = useStyles();
  const anchorRef = useRef(null);
  const anchorRefMultilevel = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [openNestedMenu, setOpenNestedMenu] = useState({});

  useEffect(() => {
    if (multiLevelOptions && multiLevelOptions.length > 0) {
      multiLevelOptions.map(({ label }) =>
        setOpenNestedMenu(state => ({ ...state, [label]: false }))
      );
    }
  }, [multiLevelOptions]);
  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };
  const handleNestedMenuOpen = label => {
    setOpenNestedMenu(state => ({ ...state, [label]: true }));
  };
  const handleNestedMenuClose = label => {
    setOpenNestedMenu(state => ({ ...state, [label]: false }));
  };

  const handleOptionToggle = (event, key, index, type) => {
    let chipsValue = [...value];
    let data;
    if (event.target.checked) {
      if (type === 'radio') {
        if (chipsValue.includes(event.target.value)) {
          data = [];
          chipsValue = chipsValue.filter(value => value !== event.target.value);
        } else {
          data = [event.target.value];
          chipsValue = chipsValue.filter(val => !options.includes(val));
          chipsValue.push(event.target.value);
        }
      } else {
        data = [...selectedFilters[key], event.target.value];
        chipsValue.push(event.target.value);
      }
    } else {
      chipsValue = chipsValue.filter(item => item !== event.target.value);
      const items = [...selectedFilters[key]];
      data = items.filter(item => item !== event.target.value);
    }
    setSelectedFilters(prevState => ({
      ...prevState,
      [key]: data,
    }));
    if (onChange) {
      onChange(chipsValue, key);
    }
  };
  const handleMenuOptionClick = (optionValue, key, label, parentLabel) => {
    let chipsValue = [...value];
    let data;
    if (chipsValue.includes(`${parentLabel}-${label}-${optionValue}`)) {
      chipsValue = chipsValue.filter(item => item !== `${parentLabel}-${label}-${optionValue}`);
      data = selectedFilters[key].filter(item => item !== `${parentLabel}-${label}-${optionValue}`);
    } else {
      chipsValue = chipsValue.filter(val => !val.includes(`${parentLabel}-${label}`));
      chipsValue.push(`${parentLabel}-${label}-${optionValue}`);
      data = [
        ...selectedFilters[key].filter(val => !val.includes(`${parentLabel}-${label}`)),
        `${parentLabel}-${label}-${optionValue}`,
      ];
    }
    setSelectedFilters(prevState => ({
      ...prevState,
      [key]: data,
    }));
    if (onChange) {
      onChange(chipsValue, key);
    }
  };
  const parentLabel = label;
  return (
    <>
      <Button onClick={handleMenuOpen} ref={anchorRef}>
        {label}
        <ArrowDropDownIcon />
      </Button>
      {labelType === 'multiLevel' ? (
        <Menu
          anchorEl={anchorRef.current}
          className={classes.menu}
          elevation={1}
          onClose={handleMenuClose}
          open={openMenu}
          PaperProps={{ style: { marginTop: '50px' } }}
        >
          <Box display="flex" alignItems="center">
            {multiLevelOptions &&
              multiLevelOptions.map(({ label, options }, index) => {
                return (
                  <MenuItem key={index} className={classes.menuItem}>
                    <Button onClick={() => handleNestedMenuOpen(label)} ref={anchorRefMultilevel}>
                      {label}
                      <ArrowDropDownIcon />
                    </Button>
                    <Menu
                      anchorEl={anchorRefMultilevel.current}
                      className={classes.menu}
                      elevation={1}
                      onClose={() => handleNestedMenuClose(label)}
                      open={openNestedMenu[label]}
                      PaperProps={{ style: { marginTop: '40px' } }}
                    >
                      {options.map(option => (
                        <MenuItem className={classes.menuItem} key={option}>
                          <FormControlLabel
                            className={classes.formControlLabel}
                            control={<p></p>}
                            label={option}
                            onClick={() =>
                              handleMenuOptionClick(option, optionKey, label, parentLabel)
                            }
                          />
                        </MenuItem>
                      ))}
                    </Menu>
                  </MenuItem>
                );
              })}
          </Box>
        </Menu>
      ) : (
        <Menu
          anchorEl={anchorRef.current}
          className={classes.menu}
          elevation={1}
          onClose={handleMenuClose}
          open={openMenu}
          PaperProps={{ style: { minWidth: 250, marginTop: 50 } }}
        >
          {options.map((option, index) => (
            <MenuItem className={classes.menuItem} key={option}>
              <FormControlLabel
                className={classes.formControlLabel}
                control={
                  optionType === 'radio' ? (
                    <Radio
                      checked={value.indexOf(option) > -1}
                      onClick={e => handleOptionToggle(e, optionKey, index, optionType)}
                      value={option}
                    />
                  ) : (
                    <Checkbox
                      checked={value.indexOf(option) > -1}
                      onClick={e => handleOptionToggle(e, optionKey, index, optionType)}
                      value={option}
                    />
                  )
                }
                label={option}
              />
            </MenuItem>
          ))}
        </Menu>
      )}
    </>
  );
}

export { CustomSearch };
